let reg = /"([^"]+)"\s*=\s*"([^"]+)"/g

// 简单实现
// 需要提前Load所有文本然后init
Localization = {
    textMap: {},

    getInstance() {
        return this
    },

    init(content) {
        Object.assign(this.textMap, content)
    },

    // parse(content) {
    //     while ((res = reg.exec(content)) !== null) {
    //         if (res[1] && res[2]) {
    //             this.textMap[res[1]] = res[2].replace(/\\n/g, '\n')
    //         } else {
    //             console.error('Localization: wrong format - "' + res[0] + '"')
    //         }
    //     }
    // },

    getText(key, param, defaultvalue) {
        let text
        if (defaultvalue) {
            text = this.textMap[key] || defaultvalue
        }else {
            text = this.textMap[key] || key
        }
        if (param) {
            for (let r in param) {
                text = text
                // 可能会需要多次替换
                // text = text.replace('{' + r + '}', param[r])
                let keyStr = '{' + r + '}';
                if (text.indexOf(keyStr) >= 0)
                    text = text.split(keyStr).join(param[r]);
            }
        }
        return text
    }
}

Localization.loadFile = Localization.parse = Localization.init

module.exports = Localization
